import { MethodName } from "./admin-rule-models";
import { SalesChannel } from "./model";

export enum BookingConfigurationStatus {
  FirstTimeScheduling = "FirstTimeScheduling",
  ReschedulingNeeded = "ReschedulingNeeded"
}

export interface SnoozeRange {
  startCount: number;
  endCount: number;
  snoozeDuration: number;
  timeFrame: string;
}

export interface BookingConfiguration {
  id?: number;
  feId?: string;
  createdDate: string; // Use string to represent DateTime
  lastModifiedDate: string; // Use string to represent DateTime
  createdBy: string;
  salesChannel: SalesChannel; // Assuming SalesChannel is defined elsewhere
  bookingStatus: BookingConfigurationStatus;
  abTestingFragment: string;
  snoozeRanges: SnoozeRange[];
  isDeleted?: boolean;
}

export interface BookerLeague {
  id: number;
  name: string;
  bookerIds: string;
  maxPriority: number;
  isEnabled: boolean;
  salesChannel: SalesChannel;
  isDeleted: boolean;
  createdDate: string;
  lastModifiedDate: string;
}

export enum TimeFrames {
  m = "Minutes",
  H = "Hours",
  D = "Days",
  W = "Weeks",
  M = "Months"
}

export const salesChannelOptions = Object.keys(SalesChannel).map(key => ({
  label: `${SalesChannel[key as keyof typeof SalesChannel]}`,
  value: SalesChannel[key as keyof typeof SalesChannel]
}));

export const bookingStatusOptions = Object.keys(BookingConfigurationStatus).map(key => ({
  label: `${BookingConfigurationStatus[key as keyof typeof BookingConfigurationStatus]}`,
  value: BookingConfigurationStatus[key as keyof typeof BookingConfigurationStatus]
}));

export const timeFrameOptions = Object.keys(TimeFrames).map(key => ({
  label: `${TimeFrames[key as keyof typeof TimeFrames].toString()}`,
  value: key
}));
export interface SlotConfiguration {
  id: number;
  feId: string;
  title: string;
  maxSlotsPerDay: number;
  salesLeague: number;
  salesChannel: SalesChannel;
  productType: string;
  paymentModel: string;
  department: string;
  createdBy: string;
  isDeleted: boolean;
  createdDate: string;
  lastModifiedDate: string;
}

export interface BookingReservation {
  id: string;
  signUpId: string;
  globalCustomerId: string;
  scheduledByAzureId: string;
  eventId: string;
  startDate: string;
  createdDate: string;
  slotId: number;
  status: string;
  methodSource: MethodName;
  currentUserId: string;
  marketingCampaign?: string | null;
  tier: string;
  paymentModel: string;
  referrerSeller: string;
  salesManagerFirstName: string;
  salesManagerLastName: string;
}

export interface QualifyingAnswerExport {
  answers: Record<string, string>;
  opportunityInternalId: string;
  signupId: string;
  createdDate: string;
}

export interface NoeticaAutodialAdminConfig {
  cliRotationNumbers: string[];
  blockedPhoneNumbers: string[];
  lastModifiedUtc: string;
  modifiedBy: string | null;
}

export type UploadFrequency = 'None' | 'Hourly' | 'RealTime' | 'Manual';

export interface AutodialerBucketConfiguration {
  id: string;
  name: string;
  description?: string;
  autodialerBucketId: string;
  autodialerBucketName: string;
  salesChannels: string[];
  priorities: number[];
  uploadFrequency: UploadFrequency;
  opportunityStatus?: string;
  isActive: boolean;
  lastModifiedUtc: string;
  modifiedBy: string;
}

export interface AutodialerBucketConfigurationRequest {
  id?: string;
  name: string;
  description?: string;
  autodialerBucketId: string;
  autodialerBucketName: string;
  salesChannels: string[];
  priorities: number[];
  uploadFrequency: UploadFrequency;
  opportunityStatus?: string;
  isActive: boolean;
  lastModifiedUtc: string;
}